<template>
  <div>
    <div class="auth-box">
      <div class="auth-logo">
        <img class="auth-img" src="http://cnbj1.fds.api.xiaomi.com/assets/emi/index/auth.png" alt="小米营销认证"/>
        <p class="auth-text">小米营销认证</p>
      </div>
      <div class="auth-desc">
        <p class="title">关于小米营销认证</p>
        <p class="text">
          小米广告营销职业认证是针对效果广告代理商专业人才进行的职业资格认证。
          覆盖网服、电商、金融、旅游、房产、教育等细分行业。
          通过搭建完整培训和考核计划，提升代理商专业人才对小米资源的认知及EMI平台优化能力，
          推动更好的营销解决方案落地。
        </p>
      </div>
      
    </div>
    <div class="auth-tab" ref="tab">
      <div class="auth-tab-nav">
        <div 
          class="tab-item" 
          v-for="tab in tabs" 
          :key="tab.id"
          :class="{'active': active === tab.id}"
        >
          <span @click="changeTab(tab.id)">{{ tab.name }}</span>
          <em class="arrow" v-if="active === tab.id"></em>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'auth',
    data() {
      return {
        tabs: [
          {name: '认证简介', id: 'introduce'},
          {name: '认证规则', id: 'rule'},
          {name: '认证查询', id: 'query'}
        ],
        active: 'introduce'
      }
    },
    created() {
      this.active = this.$route.name;
    },
    methods: {
      changeTab(id) {
        this.active = id;
        this.$router.push({name: id});
      },
    }
  }
</script>
<style lang="scss">
@import "../../assets/scss/auth.scss";
</style>